import { lightTheme, MeetingProvider } from 'amazon-chime-sdk-component-library-react';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { createArray } from '../../utils/array';
import { SessionContext } from './session-provider';
import { Video } from './video';
import { VideoConfigProvider } from './video-config-provider';
export var FakeVideoComponent = function (_a) {
    var attendeesCount = _a.attendeesCount, layout = _a.layout, _b = _a.mobile, mobile = _b === void 0 ? false : _b;
    var attendees = createArray(attendeesCount).map(function (_, index) { return index.toString(); });
    var currentAttendeeId = '1';
    var sharingAttendeeId = '';
    var focusedAttendeeId = '2';
    return (React.createElement(ThemeProvider, { theme: lightTheme },
        React.createElement(SessionContext.Provider, { value: { attendees: attendees, currentAttendeeId: currentAttendeeId, sharingAttendeeId: sharingAttendeeId, focusedAttendeeId: focusedAttendeeId } },
            React.createElement(MeetingProvider, null,
                React.createElement(VideoConfigProvider, { layout: layout, mobile: mobile, getParticipantName: function () { return 'Name Surname'; }, texts: {} },
                    React.createElement(Video, null))))));
};
//# sourceMappingURL=fake-component.js.map